import { CarHireDepotDetails } from '@shared/shared/interfaces/travel-car-hire.interfaces';
import * as fromActions from '../actions/car-hire-details.actions';

export const initialState: CarHireDepotDetails = {
  dropOffDepot: {
    name: '',
    supplier: {
      id: '',
      name: '',
    },
    address: {
      line1: '',
      line2: '',
      line3: '',
      city: '',
      state: '',
      postcode: '',
      country: '',
      location: {
        latitude: '',
        longitude: '',
        timezone: '',
      },
    },
    contact_details: {
      phone_number: '',
    },
  },
  pickUpDepot: {
    name: '',
    supplier: {
      id: '',
      name: '',
    },
    address: {
      line1: '',
      line2: '',
      line3: '',
      city: '',
      state: '',
      postcode: '',
      country: '',
      location: {
        latitude: '',
        longitude: '',
        timezone: '',
      },
    },
    contact_details: {
      phone_number: '',
    },
  },
};

export function reducer(state = initialState, action: fromActions.CarHireDetailsActions): CarHireDepotDetails {
  switch (action.type) {
    case fromActions.GET_CAR_HIRE_DETAILS_SUCCESS:
      return {
        ...state,
        [action.payload.depot]: {
          ...state[action.payload.depot],
          ...action.payload.data,
        },
      };

    case fromActions.GET_CAR_HIRE_DETAILS_FAILURE:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
